import { createContext } from 'react';

const SubscriptionContext = createContext(null);

export default SubscriptionContext;
